import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronLeftSvg from 'images/v5/icons/chevron-left.svg';
import ChevronRightSvg from 'images/v5/icons/chevron-right.svg';
import Button from 'layout/atoms/Button/Button';
import styles from './Pagination.module.scss';
function getPaginationRange(currentPage, totalPages) {
    if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const leftIndex = Math.max(currentPage - 1, 2);
    const rightIndex = Math.min(currentPage + 2, totalPages - 1);
    const showLeftDots = leftIndex > 2;
    const showRightDots = rightIndex < totalPages - 1;
    const result = [1];
    if (showLeftDots)
        result.push('dots-left');
    for (let i = leftIndex; i <= rightIndex; i += 1) {
        result.push(i);
    }
    if (showRightDots)
        result.push('dots-right');
    result.push(totalPages);
    return result;
}
function Pagination({ currentPage, pageNumbers, pageSize, hasNextPage, isLoading, itemsCount, totalCount, onPreviousPage, onNextPage, onGoToPage, }) {
    var _a;
    const { t } = useTranslation(['common']);
    const effectiveTotal = totalCount !== null && totalCount !== undefined ? totalCount : itemsCount;
    const paginationText = t('pagination_show_items_of_total', {
        count: itemsCount,
        total: effectiveTotal,
    });
    const effectiveTotalPages = pageSize && totalCount
        ? Math.ceil(totalCount / pageSize)
        : ((_a = pageNumbers[pageNumbers.length - 1]) !== null && _a !== void 0 ? _a : 1);
    const paginationRange = getPaginationRange(currentPage, effectiveTotalPages);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.info }, paginationText),
        React.createElement("div", { className: styles.controls },
            React.createElement(Button, { theme: "ghost", onClick: onPreviousPage, disabled: currentPage === 1 || isLoading, leftIcon: React.createElement(ChevronLeftSvg, null), size: "s" }, t('previous')),
            paginationRange.map((item) => item === 'dots-left' || item === 'dots-right' ? (React.createElement("span", { key: item, className: styles.ellipsis }, "...")) : (React.createElement(Button, { key: item, theme: currentPage === item ? 'fill' : 'ghost', shape: "squared", onClick: () => onGoToPage(item), disabled: isLoading }, item))),
            React.createElement(Button, { theme: "ghost", onClick: onNextPage, disabled: !hasNextPage || isLoading, rightIcon: React.createElement(ChevronRightSvg, null), size: "s" }, t('next')))));
}
export default memo(Pagination);
